import React from 'react';

import BaseModal from '../../components/BaseModal';
import ButtonPrimary from '../../components/ui/ButtonPrimary';
import ButtonTransparent from '../../components/ui/ButtonTransparent';

const StatusCancelModal = (props) => {
  const headerTitle = `"${props.job.name} Group" Job`; 
  const bodyTitle = `"${props.job.name} Group" job`; 

  const body = (
    <div className="status-cancel__body">
      <h2 className="modal__body-title">
        <span className="modal__body-cancel">Cancel </span>
        {headerTitle}
      </h2>
      <p className="modal__body-text">
        {`Are you sure you want to cancel ${bodyTitle}?`}
      </p>
    </div>
  );

  const footer = (
    <div className="status-cancel__footer">
      <ButtonPrimary onClick={props.onConfirm} name={'Yes, cancel'}/>
      <ButtonTransparent onClick={props.onClose} name={'No, don\'t cancel'}/>
    </div>
  );

  return (
    <BaseModal body={body} footer={footer} onClose={props.onClose}/>
  );
}

export default StatusCancelModal;